module.exports = __webpack_public_path__ + "static/ecan-ipad-fb84d2b0ddb866dbc809ce5adb9d2798.mp4";